import { ADD_ADMIN_SURVEY, ADD_ADMIN_SURVEYS, UPDATE_ADMIN_SURVEY, DELETE_ADMIN_SURVEY } from './actions';

// Initial State
const initialState = [];

const surveyReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_ADMIN_SURVEY: {
               const newSurveyList = [...state];
               newSurveyList.push(action.payload);

               return newSurveyList;
          }

          case ADD_ADMIN_SURVEYS: {
               return action.payload;
          }

          case UPDATE_ADMIN_SURVEY: {
               const surveyList = [...state];
               const newSurveyList = [];

               for (let i = 0; i < surveyList.length; i++) {
                    const survey = surveyList[i];

                    if (survey.id === action.payload.id) {
                         newSurveyList.push({ ...survey, ...action.payload });
                         continue;
                    }

                    newSurveyList.push(survey);
               }

               return newSurveyList;
          }

          case DELETE_ADMIN_SURVEY: {
               const surveyList = [...state];

               return surveyList.filter((survey) => survey.id !== action.payload);
          }

          default:
               return state;
     }
};

// Get post by cuid
export const getSurveySectionById = (state, surveyId, sectionId) =>
     state.admin.surveys.find((survey) => survey.id === surveyId)?.surveySections.find((item) => item.id === sectionId);

export default surveyReducer;
